// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expandedViewer_aNfEb {
  background-color: var(--color-white);
  width: 100%;
  height: 100%;
}

.expandedViewer_aNfEb div[data-expanded="true"] {
  height: 100%;
}

.expandedViewer_aNfEb div[data-expanded="true"] > * {
  height: 100%;
}

.expandedViewer_aNfEb div[data-expanded="true"] > * > :nth-child(2) > * {
  height: 100%;
}

.expandedViewer_aNfEb div[data-expanded="true"] > * > :nth-child(2) > * > * {
  height: 100% !important;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/dataViewers/dashboard/ExpandedCardWrapper.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".expandedViewer {\n  background-color: var(--color-white);\n  width: 100%;\n  height: 100%;\n}\n\n.expandedViewer div[data-expanded=\"true\"] {\n  height: 100%;\n}\n\n.expandedViewer div[data-expanded=\"true\"] > * {\n  height: 100%;\n}\n\n.expandedViewer div[data-expanded=\"true\"] > * > :nth-child(2) > * {\n  height: 100%;\n}\n\n.expandedViewer div[data-expanded=\"true\"] > * > :nth-child(2) > * > * {\n  height: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"expandedViewer": `expandedViewer_aNfEb`
};
export default ___CSS_LOADER_EXPORT___;
